import { SpeedDialDesignTokens } from '@primeuix/themes/aura/speeddial';

export const speedDialTokens: SpeedDialDesignTokens = {
  root: {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}',
  },
};
